/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const coolingHVACEnumsFaultTypeOptionEnum = {
    Overload: 'Overload',
    ShortCircuit: 'ShortCircuit',
    BreakerTrip: 'BreakerTrip',
    Other: 'Other',
} as const;

export type CoolingHVACEnumsFaultTypeOptionEnumKey =
    (typeof coolingHVACEnumsFaultTypeOptionEnum)[keyof typeof coolingHVACEnumsFaultTypeOptionEnum];

export type CoolingHVACEnumsFaultTypeOption = CoolingHVACEnumsFaultTypeOptionEnumKey;
